import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CategoriesApi } from '../../apis';
import { NewCategory } from '../../models/categories';
import { QueryKeys } from '../query-keys';

const useCreateCategory = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (newCategory: NewCategory) => CategoriesApi.create(newCategory),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CATEGORIES] });
    },
  });

  return {
    createCategory: mutation.mutateAsync,
    isCreating: mutation.isPending,
    wasCreatedWithSuccess: mutation.isSuccess,
    wasCreatedWithoutSuccess: mutation.isError,
  };
};

export default useCreateCategory;
